module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Qacuta/Kanagawa_Qacuta_HadGEM2_RCP85_Now.png";